import { snakeCaseConverter } from '@app/common/helpers';
import axios, { AxiosResponse } from '@app/common/setup/axiosWithHeader';

export const createImpersonateSession = (publisherId: string): Promise<AxiosResponse<unknown>> => {
  return axios.post(
    '/api_internal/v1/impersonate',
    snakeCaseConverter({ impersonate: { publisherId } })
  );
};

export const deleteImpersonateSession = (): Promise<AxiosResponse<unknown>> => {
  return axios.delete('/api_internal/v1/impersonate');
};
